/**
 * Shared CGU config fetch for router sas d'entrée + UI (gate, footer).
 */

import { queryOptions } from "@tanstack/react-query";

import { CGU_CONFIG_QUERY_KEY } from "@/constants/cgu-query-keys";
import { apiClient } from "@/lib/api/client";

export function cguConfigQueryOptions() {
  return queryOptions({
    queryKey: CGU_CONFIG_QUERY_KEY,
    queryFn: () => apiClient.getCguConfig(),
    staleTime: 60_000,
  });
}
